<template lang="pug">
    form(@submit.prevent="submit", class="scan-filters inset-16")
        div(class="after-16", :class="{'flex-flex' : $media.l}")
            div(class="end-16 text-semibold mf-label", v-html="$t('select_filters_intro')")
            div(:class="$media.l? 'start-32' : 'before-lg'")
                ib-field(
                    name="Fund Search",
                    ref="fundSearch",
                    v-model="identifier",
                    class="fund-search outsetx-0",
                    width="40ch",
                    :class="{'before-16' : !$media.l}"
                    :placeholder="$t('search_isin_cusip_ticker_fund')",
                    :maxlength="30"
                )
                div(
                    class="fs7 fg-error invalid-input",
                    :class="{'show':invalidInput}"
                ) {{ $t('match_requested_format') }}
        div(class="border-bottom insety-16 uppercase fg70", v-text="$t('filters')")
        InvestorResidency(@showResidence="getResidence", ref="investorResidency")
        FundFamily(@showFundFamily="getFundFamily", ref="fundFamily")
        div(class="s12 insety-16 border-bottom")
            div(class="after-16 before-8", :class="{'flex-flex' : $media.l}")
                div(class="text-semibold mf-label") {{ $t('commission_charged') }}
                div(class="after-16", :class="$media.l? 'start-32' : 'before-16'")
                    ib-radio(class="end-16 big-mobile", name="transFee", v-model="selected", val="All") {{ $t('all') }}
                    ib-radio(class="end-16 big-mobile", name="transFee", v-model="selected", val="T") {{ $t('yes') }}
                    ib-radio(class="end-16 big-mobile", name="transFee", v-model="selected", val="F") {{ $t('no') }}
        FundType(@showFundType="getFundType", ref="fundType")
        SubmitForm(:disabled="disabled", @onReset="resetFilters", ref="submitForm")
</template>

<script>
    import { mapState } from 'vuex'
    import InvestorResidency from './InvestorResidency.vue'
    import FundFamily from './FundFamily.vue'
    import FundType from './FundType.vue'
    import SubmitForm from './SubmitForm.vue'
    import api from '../api/'

    export default {
        name: 'ScanFilters',

        components: {
            InvestorResidency,
            FundFamily,
            FundType,
            SubmitForm
        },

        data() {
            return {
                checkBoolean: [
                    { label: this.$t('yes'), value: 'T' },
                    { label: this.$t('no'), value: 'F' },
                    { label: this.$t('all'), value: 'All' }
                ],
                countryLabel: '',
                disabled: true,
                fundFamily: '',
                fundType: '',
                identifier: '',
                residence: '',
                selected: 'All',
                transFee: 'All',
                transLabel: 'All',
                invalidInput: false
            }
        },

        methods: {
            checkFields() {
                this.residence !== '' ? this.disabled = false : this.disabled = true;
            },
            getFundFamily(selected) {
                this.fundFamily = selected;
                this.checkFields();
            },
            getFundType(selected) {
                this.fundType = selected;
                this.checkFields();
            },
            getResidence(selected) {
                this.residence = selected;
                this.checkFields();
            },
            getTransFee() {
                this.transFee = this.selected;
                const curFee = this.checkBoolean.filter(fee => fee.value === this.selected);
                this.transLabel = curFee[0].label;
                this.checkFields();
            },

            clearFiltersInQueryUrl() {
                this.$store.dispatch('fundscanner/setFiltersFromUrl', {});
                this.$router.replace({ query: {} });
            },

            resetFilters() {
                this.clearFiltersInQueryUrl();
                this.$refs.investorResidency.reset();
                this.$refs.fundFamily.reset();
                this.$refs.fundType.reset();
                this.selected = 'All';
                this.residence = { label: this.$t('USA'), value: 'USA' };
                this.fundFamily = 'All';
                this.transFee = 'All';
                this.transLabel = 'All';
                this.fundType = 'All';
                this.identifier = '';
                this.checkFields();
                this.invalidInput = false;
            },

            submit() {
                if (this.invalidInput) {
                    return false;
                }
                const filters = {
                    identifier: this.identifier,
                    residency: this.residence.value,
                    family: this.fundFamily,
                    txnfee: this.transFee,
                    itype: this.fundType
                };
                const fundFields = {
                    identifier: this.identifier,
                    residence: this.residence.label,
                    fundFamily: this.fundFamily,
                    transLabel: this.transLabel,
                    fundType: this.fundType
                };
                this.$emit('onSubmit', fundFields, filters);
            },
        },

        computed: {
            ...mapState('fundscanner', [
                'urlFilters'
            ])
        },

        mounted() {
            this.identifier =  this.urlFilters && this.urlFilters.identifier || '';
            this.selected =  this.urlFilters && this.urlFilters.txnfee || 'All';
            this.transFee = 'All';
            this.transLabel = 'All';
        },

        watch: {
            selected: {
                handler: function() {
                    this.getTransFee();
                }
            },

            identifier: {
                handler(val) {
                    this.invalidInput = /[<>]/.test(val) ? true : false;
                }
            }
        }
    }
</script>

<style lang="less">
.scan-filters {
    .fund-search {
        min-width: 400px;
    }
    .mf-label {
        text-transform: capitalize;
        max-width: 20em;
        width:100%;
    }
    .invalid-input {
        visibility: hidden;
        &.show {
            visibility: visible;
        }
    }
}

@media (max-width: 850px) and (orientation: landscape) {
    .scan-filters {
        .big-mobile {
            ._cbc {
                width: 48px;
                height: 48px;
                line-height: 32px;
            }
        }
    }
}

@media (max-width: 600px) {
    .scan-filters {
        .fund-search {
            width: 100%;
            min-width: 100%;
            .mf-label {
                font-size: 0.875em;
            }
        }
        .mf-label {
            max-width: 100%;
        }
        .big-mobile {
            ._cbc {
                width: 48px;
                height: 48px;
                line-height: 32px;
            }
        }
    }
}
</style>
